<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm table-logoped">
              <thead>
                <tr>
                  <th>{{$t('NAME')}}</th>
                  <th>{{$t('USERNAME')}}</th>
                  <th>{{$t('CREATEDAT')}}</th>
                  <th>{{$t('ACTION')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in response.root">
                  <tr :key="item.fakturkoUserId">
                    <td>{{item.name}}</td>
                    <td>{{item.username}}</td>
                    <td>{{formatDate(item.createdAt)}}</td>
                    <td>
                      <button type="button" class="btn button-edit mr-2" @click="showModal(item)">{{$t('EDIT')}}</button>
                      <button type="button" class="btn button-dlt" @click="deleteRow(item.fakturkoUserId)">{{$t('DELETE')}}</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <nav>
              <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData" />
            </nav>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="formmodal" :title="modalTitle" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <b-form-group :label="$t('NAME')">
          <inputvalidation :formerror="formError" name="name">
            <b-form-input v-model="formData.name" type="text" />
          </inputvalidation>
        </b-form-group>
        <b-form-group :label="$t('USERNAME')">
          <inputvalidation :formerror="formError" name="username">
            <b-form-input v-model="formData.username" type="text" />
          </inputvalidation>
        </b-form-group>
        <b-form-group :label="$t('PASSWORD')">
          <inputvalidation :formerror="formError" name="password">
            <b-form-input v-model="formData.password" type="password" :placeholder="isEdit ? $t('LEAVEEMPTYTOSKIP') : ''" />
          </inputvalidation>
        </b-form-group>
      </div>
      <div class="text-right">
        <b-btn class="mr-2 button-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Api from '@/api/fakturko_users/FakturkoUsers';

export default
{
    name: 'FakturkoUsersWin',
    data()
    {
        return {
            response: {},
            formError: {},
            formData:
            {
                name: '',
                username: '',
                password: '',
            },
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    computed:
    {
        isEdit()
        {
            return typeof this.formData.fakturkoUserId !== 'undefined';
        },
        modalTitle()
        {
            const me = this;
            return me.isEdit ? me.$t('EDIT') : me.$t('NEW');
        },
        getParams()
        {
            const me = this;
            const data = { ...me.pagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
    methods:
    {
        async getData()
        {
            const me = this;
            try
            {
                const data = await Api.selectRow(me.getParams);
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    return;
                }
                me.response = data;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
        showModal(item)
        {
            const me = this;
            if (typeof item !== 'undefined')
            {
                me.formData = { ...item, password: '' };
            }
            me.$refs.formmodal.show();
        },
        hideModal()
        {
            const me = this;
            me.$refs.formmodal.hide();
            me.formData = { name: '', username: '', password: '' };
            me.formError = {};
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                const payload = { ...item };
                if (typeof payload.fakturkoUserId !== 'undefined')
                {
                    payload.id = payload.fakturkoUserId;
                    delete payload.fakturkoUserId;
                }

                const data = await Api.submitData(payload);
                if (data.error)
                {
                    me.$notify.notice(data);
                    me.formError = data;
                }
                else
                {
                    me.$notify.notice(data);
                    me.hideModal();
                    await me.getData();
                }
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
        deleteRow(id)
        {
            const me = this;
            me.$store.commit('setModalAlert',
                {
                    text: me.$i18n.t('AREYOUSHURE'),
                    async btnAction()
                    {
                        const data = await Api.deleteRow({ id });
                        me.$notify.notice(data);
                        await me.getData();
                    },
                });
        },
        formatDate(val)
        {
            return moment(val).format('DD.MM.YYYY HH:mm');
        },
    },
    watch:
    {
        'pagination.limit'()
        {
            const me = this;
            me.getData();
        },
        'pagination.currentPage'()
        {
            const me = this;
            me.getData();
        },
        'pagination.query'()
        {
            const me = this;

            if (me.pagination.searchTimeout !== false)
            {
                clearTimeout(me.pagination.searchTimeout);
            }

            me.pagination.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        },
    },
};
</script>
